import {FIELDS_PATTERN} from 'src/modules/event-create/constants';

const MIN_LENGTH_CODE = 2;
export const MAX_LENGTH_CODE = 40;

const ERROR_MESSAGES = {
    CODE_MIN_LENGTH: 'Please enter a correct "Event Code". "Event Code" length must be more than 1 characters',
    CODE_WRONG_CHARACTERS: 'Please enter a correct "Event Code". ' +
        'Use uppercase latin alphabet and underscore. Example: "ALERT_MAIL_VIEW"',
};

export const eventCodeValidation = (eventCode: string): string[] => {
    const errorMassages = [];
    const matches = eventCode.match(FIELDS_PATTERN.name);

    if (eventCode.length < MIN_LENGTH_CODE) {
        errorMassages.push(ERROR_MESSAGES.CODE_MIN_LENGTH);
    }

    if (matches) {
        errorMassages.push(ERROR_MESSAGES.CODE_WRONG_CHARACTERS);
    }
    return errorMassages;
};
